import type {
  ConditionArgsByKind,
  ConditionKind,
  DateFilter,
  MatchListValue,
  NumberPredicate,
  TreeConditionNode,
} from '@/components/tree-dnd/tree-dnd-types';
import { onSendDayFilter } from '@/components/tree-dnd/tree-dnd-conditions/date-filter-utils';

export function defaultDateFilter(): DateFilter {
  return onSendDayFilter();
}

export function defaultMatchList(
  match: MatchListValue['match'] = 'any'
): MatchListValue {
  return { match, ids: [] };
}

export function defaultNumberPredicate(): NumberPredicate {
  return { kind: 'atLeast', value: 1 };
}

function buildDefaultArgs(): { [K in ConditionKind]: ConditionArgsByKind[K] } {
  return {
    installedApp: { when: defaultDateFilter() },
    boughtProduct: {
      products: defaultMatchList('any'),
      when: defaultDateFilter(),
    },
    receivedNotification: { campaigns: defaultMatchList('any') },
    clickedCampaign: { campaigns: defaultMatchList('any') },
    rfmGroup: { groups: defaultMatchList('any') },
    lastNotificationAt: { when: defaultDateFilter() },
    lastAppAccessAt: { when: defaultDateFilter() },
    viewedProduct: {
      products: defaultMatchList('any'),
      when: defaultDateFilter(),
    },
    location: { locations: defaultMatchList('any') },
    lastOrder: { when: defaultDateFilter() },
    orderFrequency: {
      count: defaultNumberPredicate(),
      when: defaultDateFilter(),
    },
    totalSpend: { amount: defaultNumberPredicate() },
    hasNotificationsEnabled: {},
  };
}

export function createDefaultConditionArgs<K extends ConditionKind>(
  kind: K
): ConditionArgsByKind[K] {
  return structuredClone(buildDefaultArgs()[kind]);
}

export function createDefaultConditionNode<K extends ConditionKind>(
  kind: K
): Extract<TreeConditionNode, { kind: K }> {
  return {
    id: crypto.randomUUID(),
    type: 'condition',
    negated: false,
    kind,
    args: createDefaultConditionArgs(kind),
  } as unknown as Extract<TreeConditionNode, { kind: K }>;
}
